module.exports = __webpack_public_path__ + "resources/img/img_sqml_di2_m_jp.a7b7db41174e308e62e2c64240c5c7e4.png";